// extracted by mini-css-extract-plugin
export default {"container":"Description-module__container--Zwqe8","compact":"Description-module__compact--Lw6nW"};